<template>
  <!-- <div :class="isMeasure.isReady ? 'whole-wrap whole-wrap--measure' : 'whole-wrap whole-wrap--measure-question'"> -->
  <!-- チェック前画面 -->
  <div v-show="!isMeasure.isReady"
  :class="isWideScreen?'whole-wrap whole-wrap--measure-question-pc':'whole-wrap whole-wrap--measure-question'">
    <BurgerMenuComponentPC
    v-if="isWideScreen"
    @cancel="handleSubject"
    :isExplanationLeft="true"
    :isQuestion="true"
    :isTitle="$t('oral_frailty.title')"
    />
    <div class="measure">
      <!-- PC -->
      <div v-if="isWideScreen">
        <div class="measure-question-text measure-question-text--top-pc mt-48">
          <span v-html="$t('oral_frailty.description_prefix_pc')"></span>
          <span class="measure-question-text measure-question-text--top-red" v-html="$t('oral_frailty.description_emphasis')"></span>
          <span v-html="$t('oral_frailty.description_suffix')"></span>
        </div>
        <div class="pc-item mt-32">
          <div class="pc-item-text" v-html="$t('oral_frailty.instruction')">
          </div>
          <div class="pc-item-woman-img-question"></div>
        </div>
        <div class="flex justify-content-center mt-37">
          <div class="measure-start-text" v-html="$t('oral_frailty.ready')">
          </div>
        </div>
      </div>
      <!-- mobile -->
      <div v-else>
        <div class="measure-title measure-title--question">
          <span class="measure-title measure-title--question-sub">OF-5<br /></span>
          <span v-html="$t('test_list.test_name_oral_frailty')"></span></div>
        <div class="measure-question">
          <div class="measure-question-text measure-question-text--top">
            <span v-html="$t('oral_frailty.description_prefix')"></span>
            <span class="measure-question-text measure-question-text--top-red" v-html="$t('oral_frailty.description_emphasis')"></span>
            <span v-html="$t('oral_frailty.description_suffix')"></span>
          </div>
        </div>
        <div class="question-woman-img"></div>
        <div class="measure-question-text mt-20" v-html="$t('oral_frailty.instruction')">
        </div>
        <div class="flex justify-content-center mt-40">
          <div class="measure-start-text" v-html="$t('oral_frailty.ready')">
          </div>
        </div>
      </div>
      <div class="flex justify-content-center mt-23">
        <div class="btn btn-base-question" @click="startQuestion">{{ $t('oral_frailty.start') }}</div>
      </div>
      <div v-show="!isWideScreen" class="flex justify-content-center mt-8">
        <div class="btn btn-close" @click="handleSubject">
          <div class="btn-close-text">{{ $t('oral_frailty.cancel_check') }}</div>
        </div>
      </div>
      <div class="text-copyright">
        <div >
          {{ $t('oral_frailty.reference') }}
        </div>
        <div class="mt-8">
          © 2025 Lion Corporation. All rights reserved.
        </div>
      </div>
    </div>
  </div>

  <!-- チェック画面:結果画面 -->
  <div v-show="isMeasure.isReady && !isMeasure.isCompleted"
  :class="isWideScreen?'whole-wrap whole-wrap--measure-pc':'whole-wrap whole-wrap--measure'">
    <BurgerMenuComponentPC
      v-if="isWideScreen"
      @cancel="handleSubject"
      :isExplanationLeft="true"
      :isQuestion="true"
      :isTitle="$t('oral_frailty.title')"
      />
    <!-- チェック画面 -->
    <div class="measure measure--check">
      <div class="measure-check">
        <div>
          <div v-show="!isWideScreen" class="measure-title measure-title--check">
            <span class="measure-title measure-title--question-sub">OF-5<br /></span>
            <span v-html="$t('test_list.test_name_oral_frailty')"></span></div>
          <div class="measure-area measure-area--check">
            <div class="flex justify-content-center measure-area-herder">
              <div class="measure-area-herder measure-area-herder--back" v-if="currentQuestionIndex > 0">
                <div class="img"></div>
                <div @click="goBack" :disabled="currentQuestionIndex === 0">{{ $t('oral_frailty.back') }}</div>
              </div>
              <div class="measure-area-herder" :class="currentQuestionIndex > 0?'measure-area-herder--title':''">
                {{ $t('oral_frailty.q' + (currentQuestionIndex + 1) + '_title') }}</div>
            </div>
            <div class="flex justify-content-center">
              <div class="progress-bar-container">
                <div v-for="index in 5" :key="index" class="progress-bar" :class="{ 'active': index <= currentQuestionIndex + 1 }"></div>
              </div>
            </div>
            <div class="flex justify-content-center measure-area-main"
            :class="questions[currentQuestionIndex].subOkText?'measure-area-main--one':'measure-area-main--other'">
              <div>
                <div class="measure-area-main-question">
                  <div v-html="questions[currentQuestionIndex].headerText"></div>
                </div>
                <div class="flex justify-content-center measure-area-sub mt-24" v-if="questions[currentQuestionIndex].subOkText">
                  <div class="measure-area-sub-item">※</div>
                  <div class="measure-area-sub-text" v-html="questions[currentQuestionIndex].subOkText"></div>
                </div>
                <div class="flex justify-content-center measure-area-sub bottom mt-12" v-if="questions[currentQuestionIndex].subOkText">
                  <div class="measure-area-sub-item measure-area-sub-item--1line">※</div>
                  <div class="measure-area-sub-text" v-html="questions[currentQuestionIndex].subNoText"></div>
                </div>
              </div>
            </div>
            <div>
              <div :key="currentQuestionIndex" class="flex justify-content-center">
                <div
                  @click="selectAnswer(1)"
                  class="btn btn-base-select"
                  :class="{ active: selectedAnswer === 1 }">
                  {{ questions[currentQuestionIndex].optionYes }}
                </div>
              </div>
              <div  :key="currentQuestionIndex" class="flex justify-content-center mt-8">
                <div
                  @click="selectAnswer(0)"
                  class="btn btn-base-select"
                  :class="{ active: selectedAnswer === 0 }">
                  {{ questions[currentQuestionIndex].optionNo }}
                </div>
              </div>
            </div>
          </div>
          <div v-show="!isWideScreen" class="flex justify-content-center mt-16">
            <div class="btn btn-close" @click="handleSubject">
              <div class="btn-close-text">{{ $t('oral_frailty.cancel_check') }}</div>
            </div>
          </div>
        </div>
        <!-- コピーライト -->
        <div class="text-copyright-check">
          <div >
            {{ $t('oral_frailty.reference') }}
          </div>
          <div class="mt-8">
            © 2025 Lion Corporation. All rights reserved.
          </div>
        </div>
      </div>
    </div>
    <SavingDialog
      v-if="isSaving"
      :isComplete="isComplete"
    />
  </div>

  <!-- 結果表示 -->
  <div v-show="isMeasure.isReady && isMeasure.isCompleted"
  :class="isWideScreen?'whole-wrap whole-wrap--measure-pc':'whole-wrap whole-wrap--measure'">
    <BurgerMenuComponentPC
      v-if="isWideScreen"
      @cancel="handleSubject"
      :isTitle="$t('oral_frailty.title')"
      />
    <!-- PC -->
    <div v-if="isWideScreen" class="measure">
      <div class="pc-of mt-25">
        <div :class="oralFrailtyFlag == true ?'pc-of-left':'pc-of-left pc-of-left--good'">
          <div :class="oralFrailtyFlag == true ?'pc-of-left-result':'pc-of-left-result pc-of-left-result--good'">
            <div class="left-result-title">{{ $t('oral_frailty_result.left_title') }}</div>
            <div v-html="oralFrailtyResult"></div>
          </div>
          <div class="pc-of-left-img">
            <div :class="oralFrailtyFlag == true ?'left-img-woman':'left-img-woman left-img-woman--good'">
            </div>
          </div>
        </div>
        <div class="pc-of-right">
          <div class="pc-of-right-title-area mb-16">
            <div class="measure-result-question-title">{{ $t('oral_frailty_result.your_answers') }}</div>
            <div class="measure-result-question-title-sub">{{ $t('oral_frailty_result.rule_description') }}</div>
          </div>
          <div class="measure-result-question-title-delimiter mb-24">
            <div class="measure-result-question-title-delimiter-sub"></div>
            <div class="measure-result-question-title-delimiter-line"></div>
          </div>
          
          <div class="pc-of-right-results">
            <div v-for="(question, index) in resultQuestions" :key="index"
            :class="index === 4?'pc-of-column pc-of-column--border-none':'pc-of-column'">
              <div>{{ $t('oral_frailty.q' + question.number + '_title') }}</div>
              <div class="pc-of-question">
                <div class="mt-4 pc-of-question-example pc-of-question-example--text">{{ question.content }}</div>
                <div v-if="answers && answers[index] !== undefined" class="ml-12"
                :class="{
                'pc-of-question-situation pc-of-question-situation--ok': answers[index] === 1,
                'pc-of-question-situation': answers[index] === 0}">
                  <div class="check-container">
                    <img :src="answers[index] === 1 ? checkOnImage : checkOffImage" alt="check" class="check-image" />
                  </div>
                  {{ answers[index] === 1 ? question.optionYes : question.optionNo }}
                </div>
              </div>
              <div :class="index === 4?'pc-of-question-border pc-of-question-border--none':'pc-of-question-border'" ></div>
            </div>
          </div>
          <div class="pc-of-question-border pc-of-question-border--log"></div>
          <div class="flex justify-content-center">
            <div class="btn btn-base-check btn-base-check--pc" @click="resetQuestion"> <!-- アイコン変更予定（要注意）-->
              <div class="measure-result-start-over"></div>
              {{ $t('oral_frailty_result.start_over') }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-content-center mt-64">
        <div class="btn btn-question-top" @click="handleSubject">{{ $t('oral_frailty_result.back_to_list') }}</div>
      </div>
      <div class="text-copyright-result mt-64">
        <div >
          {{ $t('oral_frailty.reference') }}
        </div>
        <div class="mt-8">
          © 2025 Lion Corporation. All rights reserved.
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div v-else class="measure">
      <div v-show="!isWideScreen" class="measure-title measure-title--check">
        <span class="measure-title measure-title--question-sub">OF-5<br /></span>
        <span v-html="$t('oral_frailty_result.title')"></span>
      </div>
      <div
      :class="oralFrailtyFlag == true ?'oral-frailty-result':'oral-frailty-result oral-frailty-result--good'">
        <div
        :class="oralFrailtyFlag == true ?'result-column':'result-column result-column--good'"
        >
          <div class="result-column-title result-column-title--big">{{ $t('oral_frailty_result.left_title') }}</div>
          <div class="result-column-text result-column-text--big" v-html="oralFrailtyResult"></div>
        </div>
        <div class="oral-frailty-imgs">
          <div :class="oralFrailtyFlag == true ?'oral-frailty-result-img':'oral-frailty-result-img oral-frailty-result-img--good'">
          </div>
        </div>
      </div>

      <div class="measure-result measure-result--question mt-47">
        <div class="measure-result-question-title mb-10">{{ $t('oral_frailty_result.your_answers') }}</div>
        <div class="measure-result-question-title-sub mb-20">{{ $t('oral_frailty_result.rule_summary') }}</div>
        <div class="measure-result-question-title-delimiter mb-8">
          <div class="measure-result-question-title-delimiter-sub"></div>
          <div class="measure-result-question-title-delimiter-line"></div>
        </div>

        <div class="measure-result-question"
        v-for="(question, index) in resultQuestions" :key="index"
        :class="index === 4?'measure-result-question--last':''">
          <div class="measure-result-question-example">
            <div class="measure-result-question-example measure-result-question-example--number">{{ $t('oral_frailty.q' + question.number + '_title') }}</div>
            <div class="mt-4">{{ question.content }}</div>
          </div>
          <div class="measure-result-question-situation"
          v-if="answers && answers[index] !== undefined"
          :class="{'measure-result-question-situation--ok': answers[index] === 1, 'measure-result-question-situation--ng': answers[index] === 0}">
            <div class="check-container">
              <img :src="answers[index] === 1 ? checkOnImage : checkOffImage" alt="check" class="check-image" />
            </div>
            {{ answers[index] === 1 ? question.optionYes : question.optionNo }}
          </div>
        </div>
        <div class="flex justify-content-center">
          <div class="btn btn-base-check" @click="resetQuestion">
            <div class="measure-result-start-over"></div>
            {{ $t('oral_frailty_result.start_over') }}
          </div>
        </div>
      </div>
      <div class="flex justify-content-center mt-16">
        <div class="btn btn-question-top mt-23" @click="handleSubject">{{ $t('oral_frailty_result.back_to_list') }}</div>
      </div>
      <div class="text-copyright-result mt-40">
        <div >
          {{ $t('oral_frailty.reference') }}
        </div>
        <div class="mt-8">
          © 2025 Lion Corporation. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';
import { formatDate, formatTime, formatFileData, formatFileName, formatTimeStamp } from './common/dateFormatter';
import SavingDialog from '@/components/SavingDialog.vue';
import BurgerMenuComponentPC from './BurgerMenuPc.vue';
import checkOnImage from '@/assets/img/measure-result-check-on.png';
import checkOffImage from '@/assets/img/measure-result-check-off.png';

export default {
  components: {
    SavingDialog,
    BurgerMenuComponentPC,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const $toast = useToast();
    const operatorId = router.currentRoute.value.params.operator_id;
    const taMeasurement = ref(null);

    // PC画面幅管理用
    const isWideScreen = ref(window.innerWidth >= 600);

    // 質問関係
    const currentQuestionIndex = ref(0);
    const selectedAnswer = ref(null);
    const answers = ref([undefined, undefined, undefined, undefined, undefined]);
    const score = ref(0); // 回答結果を元に計算したスコア
    const scoreMultiplier = [1, 1, 1, 1, 1]; //特定の質問で加点倍率を適用
    const thresholdScore = 2; // 判定基準

    // ダイヤログフラグ管理
    const isSaving = ref(false); //ダイヤログ表示フラグ
    const isComplete = ref(false); //ダイヤログ表示内容指定フラグ

    // フラグ管理
    const isMeasure = ref({
      isReady: false,
      isCompleted: false,
    });

    // 結果画面関係
    const vocabPerScore = ref(0);
    const oralFrailtyFlag = ref(false); // オーラルフレイルに該当の判定
    const actualFlag = ref(false); //実測値の判定//判定要素は変更される可能性アリ
    const oralFrailtyResult = ref(''); //オーラルフレイル該当文言
    const selfCheckResult = ref(''); //セルフチェック該当文言
    const actualValueResult = ref(''); //実測値該当文言

    // ストア関係
    const oralFrailtyId = ref('');
    const subjectId = ref('');
    const startDateTime = ref('');
    const measureFileData = ref('');
    const measureFileTime = ref('');
    const resultURL = ref('')
    const measurementStartTime = ref('');
    // const oralFrailtysData = store.getters['dataManagement/getOralFrailtysData'];
    // useOf5Flag.value = store.getters['dataManagement/getIsUseOf5'];
    const fetchData = () => {
      subjectId.value = store.getters['dataManagement/getSubjectId'];
      startDateTime.value = store.getters['dataManagement/getStartDateTime'];
      taMeasurement.value = store.getters['dataManagement/getMeasurements'].find(measurement => measurement.type === 'ta');
      // taのスコア取得
      vocabPerScore.value = taMeasurement.value ? taMeasurement.value.vocabPerSecond : null;
      //store保存用
      measureFileData.value = formatFileData(new Date());
      measureFileTime.value = formatFileName(new Date());
      oralFrailtyId.value =  `${subjectId.value}_of_${measureFileTime.value}.csv`;
    }

    const questions = computed(() => [
    {
          headerText: t('oral_frailty.q1_text'),
          subText: true,
          subOkText: t('oral_frailty.q1_note_line1'),
          subNoText: t('oral_frailty.q1_note_line2'),
          optionYes: t('oral_frailty.q1_option_0_19'),
          optionNo: t('oral_frailty.q1_option_20_plus')
        },
        {
          headerText: t('oral_frailty.q2_text'),
          subText: false,
          optionYes: t('oral_frailty.answer_yes'),
          optionNo: t('oral_frailty.answer_no')
        },
        {
          headerText: t('oral_frailty.q3_text'),
          subText: false,
          optionYes: t('oral_frailty.answer_yes'),
          optionNo: t('oral_frailty.answer_no')
        },
        {
          headerText: t('oral_frailty.q4_text'),
          subText: false,
          optionYes: t('oral_frailty.answer_yes'),
          optionNo: t('oral_frailty.answer_no')
        },
        {
          headerText: t('oral_frailty.q5_text'),
          subText: false,
          optionYes: t('oral_frailty.answer_yes'),
          optionNo: t('oral_frailty.answer_no')
        },
    ]);

    const resultQuestions = computed(() => [
      { number:"1", content: t('oral_frailty.q1_text').replace(/<br\/?>/g, ''), optionYes: t('oral_frailty.q1_option_0_19'), optionNo: t('oral_frailty.q1_option_20_plus') },
      { number:"2", content: t('oral_frailty.q2_text').replace(/<br\/?>/g, ''), optionYes: t('oral_frailty.answer_yes'), optionNo: t('oral_frailty.answer_no') },
      { number:"3", content: t('oral_frailty.q3_text').replace(/<br\/?>/g, ''), optionYes: t('oral_frailty.answer_yes'), optionNo: t('oral_frailty.answer_no') },
      { number:"4", content: t('oral_frailty.q4_text').replace(/<br\/?>/g, ''), optionYes: t('oral_frailty.answer_yes'), optionNo: t('oral_frailty.answer_no') },
      { number:"5", content: t('oral_frailty.q5_text').replace(/<br\/?>/g, ''), optionYes: t('oral_frailty.answer_yes'), optionNo: t('oral_frailty.answer_no') }
    ]);

    // 画面幅設定
      const updateScreenWidth = () => {
      isWideScreen.value = window.innerWidth >= 600;
    };

    // 測定開始画面
    const startQuestion = () => {
      isMeasure.value.isReady = true;
      //計測開始時間の保存
      measurementStartTime.value = formatTimeStamp(new Date());
    }

    // 回答処理
    const selectAnswer = (answer) => {
      // 回答を保存
      answers.value[currentQuestionIndex.value] = answer;
      // スコア計算
      calculateScore();
      if (currentQuestionIndex.value < questions.value.length - 1) {
        // ---------質問回答処理---------
        currentQuestionIndex.value++;
        selectedAnswer.value = null;
      } else {
        // ---------質問全て回答後処理---------
        // ダイヤログ表示
        isSaving.value = true;
        // 結果計算処理
        resultGeneration();
        isComplete.value = true;

        // 登録処理
        registOf();
      }
    };

    // スコアの計算
    const calculateScore = () => {
      score.value = answers.value.reduce((total, answer, index) => {
        // console.log('トータル:', total)
        return total + (answer === 1 ? scoreMultiplier[index] : 0);
      }, 0);
    };

    // 結果計算処理
    const resultGeneration = () => {
      // of-5に該当するか
      if(score.value >= thresholdScore){
        oralFrailtyResult.value = t('oral_frailty_result.has_frailty');
        oralFrailtyFlag.value = true;
      } else {
        oralFrailtyResult.value = t('oral_frailty_result.no_frailty');
      }

       // of-5に該当するか（taの実測値のみ）
      // if(!(vocabPerScore.value >= 6.0 || vocabPerScore.value == null)){
      //   actualFlag.value = true
      // }
    }

    // 登録処理
    const registOf = async () => {
      try {
        // S3登録処理
        await setOfToS3();
        // ストア、DB保存
        if (await setOralFrailty()) {
          isSaving.value = false;
          isMeasure.value.isCompleted = true;
        } else {
          isSaving.value = false;
          resetQuestion();
        }
      } catch (error) {
        isSaving.value = false;
        isMeasure.value.isCompleted = false;
        $toast.error(t('patk_error.save_error'), { duration: 5000 });
      }
    }

    // 検査結果をS3へ登録
    const setOfToS3 = async () => {
      try {

        // 検査終了時刻を取得
        const endDateTime = formatFileData(new Date());
        const timePart = endDateTime.substring(endDateTime.indexOf("_") + 1);

        const organizationId = store.getters['dataManagement/getOrganizationId'];
        const [datePart] = measureFileData.value.split('_');
        const dirName = `${organizationId}/${operatorId}/${datePart}/csv_data/${oralFrailtyId.value}`;

        //csvデータ作成
        const csvHeader = [
          "組織ID",
          "オペレータID",
          "測定時刻：第5問の回答を完了し、結果を記録した時刻",
          "被検査者ID",
          "OF5第1問；0：20本以上/1：0～19本",
          "OF5第2問；0：いいえ/1：はい",
          "OF5第3問；0：いいえ/1：はい",
          "OF5第4問；0：いいえ/1：はい",
          "OF5第5問；0：いいえ/1：はい",
          "OF5合計スコア",
          "OF5合計スコア（計測結果）"
        ].join(",");

        const csvRow = [
          organizationId,
          operatorId,
          timePart,
          subjectId.value,
          ...answers.value,
          score.value,
          oralFrailtyFlag.value ? t('test_list.at_risk') : t('test_list.not_at_risk'),
        ].join(",");

        const oralFrailtyCsv = `${csvHeader}\n${csvRow}`;


        const paramsS3 = {
          Key: `pataka_data/${dirName}`,
          Body: oralFrailtyCsv,
        };

        resultURL.value = paramsS3.Key;
        // console.log('S3へアップロード',resultURL.value);

        // 音声データをS3にアップロード
        const result = await store.dispatch('oralFrailtyExplanation/uploadS3', paramsS3);
        // 登録に失敗した場合エラーメッセージを表示
        if (!result.success) throw new Error(result.error);

      } catch (error) {
        $toast.error(error.message, { duration: 5000 });
        throw new Error();
      }
    };

    // 検査結果を登録する
    const setOralFrailty = async () => {
      try {
        const _date = new Date();

        // // 検査終了時刻を取得
        const endDateTime = formatTimeStamp(_date);

        // 測定データをストアにセット
        const oralFrailtyData = {
          audioId: oralFrailtyId.value,
          type: 'of',
          status: t('test_list.status_completed'),
          result: oralFrailtyFlag.value,
          score: score.value,
          date: formatDate(_date),
          time: formatTime(_date),
          measurementStartTime: measurementStartTime.value,
          isCompleted: true,
          dateVal: _date.getTime(),
        };

        const registData = {
          inspection_id: store.getters['dataManagement/getInspectionId'],
          answers1: answers.value[0],
          answers2: answers.value[1],
          answers3: answers.value[2],
          answers4: answers.value[3],
          answers5: answers.value[4],
          inspection_end_time: measurementStartTime.value,
        }

        // 検査TOP用のデータ登録（ストア）
        store.dispatch('dataManagement/setOralFrailty',oralFrailtyData);
        // チェック結果の登録（DB）
        const result = await store.dispatch('oralFrailtyExplanation/regist',registData);
        // レポート用一時保存のチェック結果の登録（ストア）
        store.dispatch('dataManagement/setOralFrailty5Data',registData);

        // OF-5のみ時の音声データの登録
        const reportData ={
          operatorId: store.getters['dataManagement/getOperatorId'],
          subject_id: store.getters['dataManagement/getSubjectId'],
          measurement_type: store.getters['dataManagement/getMeasurementType'],
          analysisTypeFlag: store.getters['dataManagement/getAnalysisTypeFlag'],
          gender: store.getters['dataManagement/getGender'],
          age: store.getters['dataManagement/getAge'],
          measurements: store.getters['dataManagement/getMeasurements'],
          endDateTime: endDateTime,
          grap: store.getters['dataManagement/getGraphData'],
        }
        const report = {
          inspection_id: store.getters['dataManagement/getInspectionId'],
          report_data:reportData,
        }

        // report（DB）に保存
        const endResult = await store.dispatch('measureExplanation/registReport', report);
        if (!endResult.success) throw new Error(endResult.error);

       // レポート用一時保存のストアへ保存
        store.dispatch('dataManagement/setMeasurementsData', reportData);

        // 登録に失敗した場合エラーメッセージを表示
        if (!result.success) throw new Error(result.error);
        return true;
      } catch (error) {
        $toast.error(error.message, { duration: 5000 });
        return false;
      }
    }


    // 回答の戻る際の処理
    const goBack = () => {
      if (currentQuestionIndex.value > 0) {
        currentQuestionIndex.value--;
        answers.value[currentQuestionIndex.value] = null; // 戻った質問の回答をリセット
        selectedAnswer.value = null;
        calculateScore();
      }
    };

    // 再度回答する際の処理
    const resetQuestion = () => {
      resetRsult(); // 判定初期化
      isMeasure.value.isReady = false;
      isMeasure.value.isCompleted = false;
    }

    // 被検査者情報ページへの遷移処理
    const handleSubject = async () => {
      resetRsult(); // 判定初期化
      router.push({
        name: 'selectMenu',
        params: {
          operator_id: operatorId,
        },
      });
    };

    // 判定初期化
    const resetRsult = () => {
      score.value = 0; // スコアリセット
      oralFrailtyFlag.value = false;
      actualFlag.value = false;
      answers.value = Array(questions.value.length).fill(null); // 回答内容をリセット
      currentQuestionIndex.value = 0; // 最初の質問に戻る
      selectedAnswer.value = null; // 選択中の解答をクリア
    }

    // 実施済みか判定
    const implemented = () => {
      const oralFrailtys = ref([]);
      const oralFrailtysData = store.getters['dataManagement/getOralFrailtysData'];
      oralFrailtys.value = store.getters['dataManagement/getOralFrailtys'];
      // 実施済みなら結果表示
      if(oralFrailtys.value.some((measure) => measure.isCompleted)){
        answers.value = Array.from({ length: 5 }, (_, i) => Number(oralFrailtysData[`answers${i + 1}`]));

        const ofResultFlag = answers.value.filter(answer => answer === 1).length >= 2;

        // 判定
        if(ofResultFlag){
          oralFrailtyResult.value = t('oral_frailty_result.has_frailty');
          oralFrailtyFlag.value = true;
        } else {
          oralFrailtyResult.value = t('oral_frailty_result.no_frailty');
        }

        // 表示フラグ更新
        isMeasure.value.isReady = true;
        isMeasure.value.isCompleted = true;
      }
    }

    // コンポーネントがマウントされたときにデータを取得
    onMounted(() => {
      updateScreenWidth();
      window.addEventListener('resize', updateScreenWidth);
      window.scrollTo(0, 0);
      fetchData();
      // updateDisplayParams();
      answers.value = Array(questions.value.length).fill(null);
      //実施済みか判定実：施済みなら結果表示
      implemented();
    });

    onBeforeUnmount(() => {
      // イベントリスナーのクリーンアップ
      window.removeEventListener('resize', updateScreenWidth);
    });

    return {
      isWideScreen,
      taMeasurement,
      isSaving,
      isComplete,
      isMeasure,
      questions,
      resultQuestions,
      currentQuestionIndex,
      selectedAnswer,
      answers,
      score,
      thresholdScore,
      actualFlag,
      oralFrailtyFlag,
      oralFrailtyResult,
      selfCheckResult,
      actualValueResult,
      startQuestion,
      selectAnswer,
      goBack,
      resetQuestion,
      handleSubject,
      resetRsult,
      checkOnImage,
      checkOffImage,
    };
  },
};

</script>

<style lang="scss" scoped>
@import '@/scss/style.scss';

button.inactive {
  color: grey;
}
button.active {
  font-weight: bold;
}

/* 進捗バーの親コンテナ */
.progress-bar-container {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 0px;
}

/* 各進捗バー */
.progress-bar {
  width: 40px;
  height: 4px;
  margin: 0 2px;
  background-color: #eaeaea;
  transition: background-color 0.3s ease;
  border-radius: 0;
}

/* バーがアクティブな場合 */
.progress-bar.active {
  background-color:#4797d5;
}

/* 左端のバーを丸くする */
.progress-bar-container .progress-bar:first-child {
  border-radius: 5px 0 0 5px;
  margin-right: 2px;
  margin-left: 0px;
}

/* 右端のバーを丸くする */
.progress-bar-container .progress-bar:last-child {
  border-radius: 0 5px 5px 0;
  margin-right: 0px;
  margin-left: 2px;
}

.check-container {
  position: absolute;
  top: 3px;
  left: 4px;
}

.check-image {
  width: 12px;
  height: 12px;
}

.measure-result-question-situation {
  position: relative;
  display: inline-block;
  margin-left: 2px;
}

</style>